"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EMPTY_DOCUMENT", {
    enumerable: true,
    get: function() {
        return EMPTY_DOCUMENT;
    }
});
var _blocks = require("./blocks.js");
var EMPTY_DOCUMENT = {
    nodeType: _blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: _blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
